// src/pages/AdminLoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useAuth } from '../AuthContext';
import './AdminLoginPage.css'; // Importa il CSS specifico

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Stato per feedback caricamento
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Se l'utente è già loggato, reindirizza alla home (gestito da AuthProvider/redirect logico)
  // Questo controllo può rimanere come ulteriore sicurezza
  React.useEffect(() => {
    if (currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);


  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true); // Inizia caricamento
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Navigate a '/' avverrà automaticamente grazie a useEffect sopra o al router se protetto
    } catch (err) {
      setError('Credenziali non valide o errore di rete. Riprova.');
      console.error("Errore login:", err);
      setLoading(false); // Termina caricamento in caso di errore
    }
    // Non serve setLoading(false) in caso di successo perché la pagina cambierà
  };

  return (
    <div className="admin-login-page">
        <div className="admin-login-container">
            <h2>Accesso Amministratore</h2>
            <p className="login-intro">Inserisci le tue credenziali per accedere all'area riservata.</p>
            <form onSubmit={handleLogin} className="admin-login-form">
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="iltuo@indirizzo.email"
                        disabled={loading} // Disabilita durante caricamento
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="********"
                        disabled={loading} // Disabilita durante caricamento
                    />
                </div>
                {error && <p className="form-status error">{error}</p>}
                <button type="submit" className="cta-button login-button" disabled={loading}>
                    {loading ? 'Accesso in corso...' : 'Login'}
                </button>
            </form>
        </div>
    </div>
  );
};

export default AdminLoginPage;